export default "__VITE_ASSET__ewdykUkA__"